import Util from '../../utilPc/';
import Events from '../../event/';
const pcVideoUtil = new Util();

class RequestAd {
    constructor(opt, videoinfo) {
        this.type = opt.type;
        this.videoinfo = videoinfo;
        this.init(opt);
    }

    init(opt) {
        const videoinfo = this.videoinfo;

        this.adData = {
            frmid: opt.frmid, // 节目页面来源，免费底页为free,纪录片为vdocumentary
            catid: videoinfo.categoryId, // 分类ID
            ADOrderFirst: opt.ADOrderFirst || 0, // 播放技术重置，0或1
            ColumnName: videoinfo.columnName, // 栏目名称
            Actor: '',
            CreateDate: videoinfo.createdate, // 创建日期,需要添加
            Duration: videoinfo.duration, // 视频时长
            Keyword: videoinfo.keywords || videoinfo.keyword, // 关键字，需要添加
            adType: opt.adType, // 平台 0:定投广告 1:图文内页广告（组合传播播放器）2:专题广告（组合传播播放器）4:纪录片（底页播放器） 5:免费底页（底页播放器） 9:牛视（底页播放器）10:直播（直播播放器） 11.站外（站外播放器）
            subject: opt.subject || '',
            provider: videoinfo.CPId || '', // 内容提供商，需要添加
            // Vwidth: parseInt(pcVideoUtil.getStyle(document.getElementById(opt.containerDom)).width), // 播放器宽
            // Vheight: parseInt(pcVideoUtil.getStyle(document.getElementById(opt.containerDom)).height), // 播放器高
            id: videoinfo.vid,
            sid: pcVideoUtil.playerGetCookie('sid'),
            currentState: opt.type || 'head', // 当前请求的状态，head pause
        };
        // console.log(this.adData, opt);

        if (typeof this.data == 'undefined') {
            const adVHeader = new AdVHeader(); // eslint-disable-line
            // debugger;

            adVHeader.setPara(this.adData, this.request.bind(this));
        }
    }

    getTest = () => {
        // type4 角标； type5 banner
        const a = {
            code: 1,
            info: [
                {
                    type: 1,
                    materialUrl: '//avideo.ifengcdn.com/mappa/2017/01/26/c091623ce99bf65a3ccf259bacdc843a.mp4', // 广告素材地址。
                    duration: 15, // 此段视频广告时长。角标，暂停广告为0.
                    clickUrl:
                        '//adclick.g.doubleclick.net/pcs/click?xai=AKAOjssY-nPNgX2OIALW2YfQ-xoj…__IESID__&v=__LOC__&xa=__ADPLATFORM__&o=https://s.click.taobao.com/e3kVtAx', // 广告跳转地址。
                    // "vol":0,
                    eventlog: {
                        start: [
                            // 开始播放监测，可有多条
                            '//dol.deliver.ifeng.com/s?z=ifeng&c=1&l=12688',
                            '//dol.deliver.ifeng.com/s?z=ifeng&c=1&l=12688',
                        ],
                        middle: [], // 播放至一半监测，角标，暂停广告为空
                        end: [], // 播放结束监测，角标，暂停广告为空
                        clickTrack: [], // 点击时发送，为空则不发送
                    },
                },
            ],
        };
        const b = {
            code: 1,
            info: [
                {
                    type: 3, // 暂停
                    materialUrl:
                        'http://c1.ifengimg.com/iamsImg/2019/02/27/73cfb45765acbd3145f71f934bc13051_w300_h250.jpg', // 广告素材地址。
                    duration: 0, // 此段视频广告时长。角标，暂停广告为0.
                    clickUrl:
                        'http://idod.ifeng.com/c?z=ifeng&la=0&si=2&cg=1&c=1&ci=2&or=20528&l=78468&bg=78468&b=138812&u=http://mfp.deliver.ifeng.com/mfp/mfpClick.do?UUIDKEY=5Lit5Zu9LeWMl-S6rOW4gi0JdglodHRwOi8vemh1amlhbi5pZmVuZy5jb20vcGNfc3RhbmQuaHRtbAktCTIzNQkxYTgxNjViMy1iZDA1LTQwYjYtODE5OS1jMmM0Yjg5MTkzMjQJMWE4MTY1YjMtYmQwNS00MGI2LTgxOTktYzJjNGI4OTE5MzI0MAk2NzM1CTIJNDQ1NwkwCS0&LandingPageURL=aHR0cHM6Ly90LmNyLW5pZWxzZW4uY29tL2Rhcj9fdD1yJnR5cGU9Y2xrJnY9MSZfaW5zdD1ubCZoYXRfY2lkPTMwMDk4MCZoYXRfcGlkPTQxOTU4OCZoYXRfYWlkPTQxNTcwNiZyPVt0aW1lc3RhbXBdJl9sPWFIUjBjSE02THk5emFHVmtaUzVxWkM1amIyMD0', // 广告跳转地址。
                    eventlog: {},
                },
            ],
        };

        if (this.type === 'pause') {
            return b;
        }

        return a;
    };

    request = obj => {
        // obj = {
        //     code: 1,
        //     info: [
        //         {
        //             type: 4, //暂停
        //             materialUrl:
        //                 '//c1.ifengimg.com/iamsImg/2018/03/23/0a969e0dd9bd7c682e589ba11955a314_w300_h250.jpg', //广告素材地址。
        //             duration: 0, //此段视频广告时长。角标，暂停广告为0.
        //             clickUrl:
        //                 '//iis1.deliver.ifeng.com/c?p=Z5Ak8dpljixX2bxXlYF-90ndztgDYCzN11NG89FYsj_KEKOAuZU3-W9mfsRvH66N9AoxEfHlWpyDiX1Hby9OnvXouYQrM542IRe8G30PVkt8eoMfDu0H3QS2Y8e_p46iGdyTRJXR6rktFbBRWgOWCDQoEMVtBt1M6-axm7hkI3uD9WgrdZ8Kkr6o3XHjuGKpz68GWgQR5sLiqwwzpeybzg', //广告跳转地址。
        //             eventlog: {},
        //         },
        //     ],
        // };

        // 测试广告数据
        // this.obj = obj = this.getTest();

        this.obj = obj;

        this.data = {};

        if (obj.code === 0 || obj.info.length === 0) {
            return this.trigger('start', this.data, this.obj);
        }

        this.data = this.formatData(obj);
        // console.log(this.data);
        // console.log(this);

        return this.trigger('start', this.data, this.obj);
    };

    formatData(obj) {
        if (!obj || obj.code === 0 || obj.info.length === 0) return {};
        const _data = {};
        const frontAd = {};

        for (const i in obj.info) {
            const _obj = obj.info[i];

            switch (_obj.type) {
                case 1: // 前贴片
                    if (!frontAd.adUrl) frontAd.adUrl = [];
                    frontAd.adUrl.push(_obj.materialUrl);
                    if (!frontAd.clickUrl) frontAd.clickUrl = [];
                    frontAd.clickUrl.push(_obj.clickUrl);
                    if (!frontAd.adTime) frontAd.adTime = 0;
                    frontAd.adTime += parseInt(_obj.duration);
                    if (!frontAd.oneadTime) frontAd.oneadTime = [];
                    frontAd.oneadTime.push(_obj.duration);
                    _data.frontAd = frontAd;
                    if (!frontAd.vol) frontAd.vol = [];
                    if (_obj.vol === 0) {
                        _obj.vol = 0;
                    } else {
                        _obj.vol = _obj.vol / 100 || 0.42; // 添加前贴片播放音量-没有则获取默认的
                    }

                    frontAd.vol.push(_obj.vol);
                    _data.frontAd = frontAd;
                    // initLayout(_data);

                    break;
                case 2: // 片头
                    if (!frontAd.adUrl) frontAd.adUrl = [];
                    frontAd.adUrl.push(_obj.materialUrl);
                    if (!frontAd.adTime) frontAd.adTime = 0;
                    frontAd.adTime += parseInt(_obj.duration);
                    if (!frontAd.oneadTime) frontAd.oneadTime = [];
                    frontAd.oneadTime.push(_obj.duration);
                    frontAd.clickUrl = [];
                    _data.frontAd = frontAd;
                    break;
                case 3: // 暂停广告
                    _data.materiaUrl = _obj.materialUrl;
                    _data.goUrl = _obj.clickUrl;
                    break;
                case 4: // 角标广告
                    _data.corner = {};
                    _data.corner.imgUrl = _obj.materialUrl;
                    _data.corner.goUrl = _obj.clickUrl;
                    break;
                case 5: // banner广告
                    if (_data.banner) break;
                    _data.banner = {};
                    _data.banner.imgUrl = _obj.materialUrl;
                    _data.banner.goUrl = _obj.clickUrl;
                    break;
                default:
                    break;
            }
        }

        return _data;
    }
}

Events.mixTo(RequestAd);
export default RequestAd;
